import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class SegmentsProvider extends HttpRequest {
  async getSegmentsByFilterID (param) {
    this.setHeader(getAuthToken())
    return this.fetch(`/segments/${param}`)
  }

  async createPromotion (payload) {
    this.setHeader(getAuthToken())
    return this.create('/segment-promotions/create-promotion', payload)
  }
}

export default SegmentsProvider
